import { Badge, Button, Card, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';
import { BOS_PTW_IZIN_SUZGECI } from '@isg/validation';
import { useIzinler } from '../api/queries';
import { GecerlilikHucresi, damga, durumRozeti } from './izin-parts';
import { SahaKuyrukPaneli } from './saha-parts';
import { QueryStatus } from './parts';

/**
 * SAHA EKRANI (F3·S5) — mobil öncelikli giriş kapısı: "şu an sahada olan
 * izinler". Liste SUNUCUDAN gelir ve süper-durum `sahada` ile daraltılır
 * (aktif · askıda · süresi dolmuş); ekran token gruplamaz, ikinci filtre
 * yazmaz (§2.16).
 *
 * Bahçesi boş kullanıcı BOŞ ekran görür (B3) — bu bir hata değil, kapsam
 * sonucudur.
 */
export function SahaScreen(): React.JSX.Element {
  // K5 (tur 10): liste ucu artık süzgeç nesnesi alır. Saha ekranı SABİT
  // `sahada` sekmesiyle çalışır ve başka süzgeç TAŞIMAZ — mobil öncelikli
  // yüzeye süzgeç şeridi eklemek, tek soruyu ("şu an sahada ne var")
  // çoğaltmak olurdu.
  const izinler = useIzinler({ ...BOS_PTW_IZIN_SUZGECI, superDurum: 'sahada' });

  return (
    <Stack maw={720}>
      <Title order={3}>Saha</Title>
      <SahaKuyrukPaneli />
      <QueryStatus queries={[izinler]} />
      {izinler.isSuccess && izinler.data.permits.length === 0 && (
        <Text size="sm" c="dimmed" data-testid="saha-bos">
          Sahada görünen izin yok. (Liste yalnız kapsamınızdaki izinleri gösterir.)
        </Text>
      )}
      {izinler.isSuccess &&
        izinler.data.permits.map((permit) => (
          <Card key={permit.id} withBorder data-permit={permit.id} data-testid="saha-izin-karti">
            <Stack gap={6}>
              <Group gap="xs">
                {durumRozeti(permit)}
                {damga(permit)}
              </Group>
              <Text fw={600}>
                {permit.workplaceAd} — {permit.locationAd}
              </Text>
              <GecerlilikHucresi permit={permit} />
              <Group gap="xs">
                <Button
                  size="xs"
                  component={Link}
                  to={`/izinler/${permit.id}/saha`}
                  data-testid="saha-ac"
                >
                  Saha adımları
                </Button>
                <Button
                  size="xs"
                  variant="default"
                  component={Link}
                  to={`/izinler/${permit.id}/qr`}
                >
                  QR
                </Button>
              </Group>
            </Stack>
          </Card>
        ))}
      {izinler.isSuccess && izinler.data.permits.length > 0 && (
        <Badge variant="light" data-testid="saha-sayaci">
          Sahada: {izinler.data.sayaclar.sahada}
        </Badge>
      )}
    </Stack>
  );
}
